import { Tag, Timeline } from 'antd';
import type { WorkOrderTransitionView } from '../work-orders.api';
import { WORK_ORDER_STATE_COLORS, WORK_ORDER_STATE_LABELS } from '../policies/work-order-labels';

interface WorkOrderHistoryProps {
  transitions: WorkOrderTransitionView[];
  currentUserId: string | null;
}

/** Every move, oldest first, with the reason where one was given. The API names the person by id only, so the viewer's own moves read "You" and the rest are left unnamed. */
export function WorkOrderHistory({ transitions, currentUserId }: WorkOrderHistoryProps) {
  const ordered = [...transitions].sort((a, b) => a.occurredAt.localeCompare(b.occurredAt));

  return (
    <Timeline
      items={ordered.map((move) => ({
        key: move.id,
        content: (
          <div className="flex flex-col gap-1">
            <div className="flex flex-wrap items-center gap-2">
              <Tag color={WORK_ORDER_STATE_COLORS[move.toState]}>{WORK_ORDER_STATE_LABELS[move.toState]}</Tag>
              <span className="text-sm text-muted">
                {new Date(move.occurredAt).toLocaleString('en-KE')}
                {move.actorId === currentUserId ? ' · You' : ''}
              </span>
            </div>
            {move.reason && <p className="m-0 text-sm">{move.reason}</p>}
          </div>
        ),
      }))}
    />
  );
}
